// The sanctioned console wrapper; eslint.config.js turns off no-console here.
import { env } from '@/app/config/env';
import type { LogLevel } from '@/app/config/env';

const RANK: Record<LogLevel, number> = { error: 0, warn: 1, info: 2, debug: 3 };

function enabled(level: LogLevel): boolean {
  return RANK[level] <= RANK[env.LOG_LEVEL];
}

export const logger = {
  error(...args: unknown[]): void {
    if (enabled('error')) console.error('[niraxobid]', ...args);
  },
  warn(...args: unknown[]): void {
    if (enabled('warn')) console.warn('[niraxobid]', ...args);
  },
  info(...args: unknown[]): void {
    if (enabled('info')) console.info('[niraxobid]', ...args);
  },
  debug(...args: unknown[]): void {
    if (enabled('debug')) console.debug('[niraxobid]', ...args);
  },
};
